import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, type PropType } from 'vue';

import { MyOrdersListType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

import TimeFromNow from './TimeFromNow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderTime',
  props: {
  forceAbsoluteTime: { type: Boolean, required: true },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  listType: { type: String as PropType<MyOrdersListType>, required: true },
},
  setup(__props) {

const props = __props;

const time = computed(() => (props.listType === MyOrdersListType.open ? props.order.time : props.order.timeLastUpdated));

return (_ctx: any,_cache: any) => {
  return (time.value)
    ? (_openBlock(), _createBlock(TimeFromNow, {
        key: 0,
        class: "order-time",
        date: time.value,
        "force-absolute-time": __props.forceAbsoluteTime
      }, null, 8, ["date", "force-absolute-time"]))
    : _createCommentVNode("", true)
}
}

})